"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationContextValue = exports.useNotificationContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const react_intl_1 = require("react-intl");
const account_context_1 = require("./account-context");
const NotificationContext = react_1.default.createContext({
    notifications: [],
    getNotifications: async () => { },
    loadMoreNotifications: async () => { },
    unseenNotificationsCount: 0,
    newNotificationsCount: 0,
    pageStats: {},
});
const useNotificationContextProvider = () => {
    const intl = (0, react_intl_1.useIntl)();
    const account = (0, account_context_1.useAccount)();
    const [notifications, setNotifications] = react_1.default.useState([]);
    const unseenNotificationsCount = react_1.default.useMemo(() => notifications.filter(n => !n.seen_at).length, [notifications]);
    const [newNotificationsCount, setNewNotificationsCount] = react_1.default.useState(0);
    const [pageStats, setPageStats] = react_1.default.useState({
        page: 0,
        total: 0,
        pageCount: 0,
    });
    const getNotifications = async () => {
        try {
            if (!account) {
                return;
            }
            const freshNotificationsWithPageStats = await Api.Account.getMyNotifications();
            setNotifications(freshNotificationsWithPageStats.notifications);
            setNewNotificationsCount(freshNotificationsWithPageStats.notifications.length);
            setPageStats({
                page: freshNotificationsWithPageStats.pagination.page,
                total: freshNotificationsWithPageStats.pagination.rowCount,
                pageCount: freshNotificationsWithPageStats.pagination.pageCount,
            });
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
    };
    const loadMoreNotifications = async () => {
        try {
            const oldNotificationsWithPageStats = await Api.Account.getMyNotifications(pageStats.page + 1);
            setNotifications([...notifications, ...oldNotificationsWithPageStats.notifications]);
            setNewNotificationsCount(oldNotificationsWithPageStats.notifications.length);
            setPageStats({
                page: oldNotificationsWithPageStats.pagination.page,
                total: oldNotificationsWithPageStats.pagination.rowCount,
                pageCount: oldNotificationsWithPageStats.pagination.pageCount,
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    return {
        NotificationContextProvider: NotificationContext.Provider,
        value: {
            notifications,
            unseenNotificationsCount,
            newNotificationsCount,
            pageStats,
            getNotifications,
            loadMoreNotifications,
        },
    };
};
exports.useNotificationContextProvider = useNotificationContextProvider;
const useNotificationContextValue = () => {
    const context = react_1.default.useContext(NotificationContext);
    return context;
};
exports.useNotificationContextValue = useNotificationContextValue;
